export {
  OpportunityDocumentsSection,
  OpportunityDocumentsTab,
  SolicitationDocumentsSection,
  SolicitationDocumentsTab,
} from '../../common/OpportunityDocumentsViewer'
export type {
  OpportunityDocumentsSectionProps,
  OpportunityDocumentsTabProps,
  SolicitationDocumentsSectionProps,
  SolicitationDocumentsTabProps,
} from '../../common/OpportunityDocumentsViewer'
